import * as Sentry from "@sentry/nextjs";
import posthog from "posthog-js";

import { telemetry } from "~/lib/telemetry";

import { denyUrls, ignoreErrors } from "./sentry.common.config";

if (!telemetry.isPosthogEnabled()) {
  telemetry.enablePosthog();
}

Sentry.init({
  dsn:
    process.env.SENTRY_DSN ||
    process.env.NEXT_PUBLIC_SENTRY_DSN ||
    "https://0e00f4fc593449ea9eb6968e3b654afb@o4504537810272256.ingest.us.sentry.io/4504537812566016",
  integrations: [Sentry.replayIntegration()],
  tracesSampleRate: 0.01,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 0.01,
  debug: false,
  ignoreErrors,
  denyUrls,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
